module.exports = __webpack_public_path__ + "static/img/report-top.e9e36537.png";